<script lang="ts" setup>
import { getTranslations } from '@monogrid/vue-boost/i18n'
import { computed, inject, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import AppCombobox from '@/components/atoms/AppCombobox.vue'
import { globalInjectionKeys } from '@/main'

import AppButtonText from '../atoms/AppButtonText.vue'

const VISION_JA_LOCALES = ['en', 'ja', 'zh']

const { locale } = inject(globalInjectionKeys.i18n)()

const route = useRoute()
const router = useRouter()

const translations = getTranslations()
const translationsKeys = Object.keys(translations)

const allTranslations = computed(() => {
  return Object.values(translations)
    .map((t, index) => ({ value: translationsKeys[index], label: t.name }))
    .sort((a, b) => (a.value !== locale.value ? 1 : -1))
    .filter((locale) => {
      if (route.name === 'AudioguideJapan') {
        return VISION_JA_LOCALES.includes(locale.value)
      }
      return locale
    })
})

watch(() => route.params, (_params) => {
  if (!VISION_JA_LOCALES.includes(_params.locale as string)) {
    router.replace({ params: { locale: allTranslations.value[0].value } })
  }
}, { immediate: true })
</script>

<template>
  <AppCombobox
    id="translation"
    :options="allTranslations"
    :tracking-data="{eventCategory: 'Click on Language' }"
    size="xs"
  >
    <template #selected="selected">{{ selected.value }}</template>
    <template #option="option">
      <AppButtonText
        :title="$t('accessibility.localeSwitcher', { msg: option.label })"
        :to="{ params: { locale: option.value }}"
        class="uppercase"
        size="xs"
        replace
      >
        {{ option.value }}
      </AppButtonText>
    </template>
  </AppCombobox>
</template>
